"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMaskSpinnerMixin = exports.LoadingMaskMixin = exports.LoadingMaskContentMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _iconSizeMixin = require("../iconSizeMixin");
var _marginMixin = require("../marginMixin");
/** @class LoadingMaskMixin */
/** @method */
var LoadingMaskMixin = function LoadingMaskMixin(props) {
  var _props$display = props.display,
    display = _props$display === void 0 ? 'inline-flex' : _props$display;
  return (0, _styledComponents.css)(["position:relative;display:", ";", ""], display, (0, _marginMixin.marginMixin)(props));
};

/** @class LoadingMaskContentMixin */
/** @method */
exports.LoadingMaskMixin = LoadingMaskMixin;
var LoadingMaskContentMixin = function LoadingMaskContentMixin(props) {
  if (!props.loading) {
    return '';
  }
  return (0, _styledToken.default)('LoadingMask.opacity', function (opacity) {
    return "\n            user-select: none;\n            opacity: " + opacity + ";\n        ";
  })(props);
};

/** @class LoadingMaskSpinnerMixin */
/** @method */
exports.LoadingMaskContentMixin = LoadingMaskContentMixin;
var LoadingMaskSpinnerMixin = function LoadingMaskSpinnerMixin(props) {
  return (0, _styledComponents.css)(["position:absolute;top:0;left:0;bottom:0;right:0;display:", ";justify-content:center;align-items:center;", ""], props.loading ? 'flex' : 'none', (0, _iconSizeMixin.iconSizeMixin)(props));
};
exports.LoadingMaskSpinnerMixin = LoadingMaskSpinnerMixin;